/* 태그는 작가가 직접 적는다(합계 최대 10개). 작품 분류는 태그 하나로 한다. */

export const MAX_TAGS = 10
export const MAX_TAG_LENGTH = 20
